<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <ReceiveForm ref="receiveForm" @toAddNewAddress="toAddNewAddress" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import ReceiveForm from './receive';
import SubBtnBox from 'components/subBtnBox';
import {
  cityCustomerOrderSaveOrUpdate,
  cityCustomerOrderQueryByCcoId,
} from 'api/distribution';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    ReceiveForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/distribution/customerOrder/edit',
      formComponents: ['baseForm', 'receiveForm'],

      // 需要对比的参数
      compareParams: {
        customerId: '',
        orderTimeStr: '',
        deliveryTime: '',
        sourceAddressName: '',

        desAddressName: '',
        desAddressDtl: '',
        quantityShipped: '',
        quantityShippedUnit: '',
        productName: '',
        productVolume: '',
        productWeight: '',
        requiredTime: '',
      },
    };
  },
  computed: {
    editParams () {
      let parmas = {};
      if (this.$route.query.id) {
        parmas.ccoId = this.$route.query.id;
      }
      return parmas;
    },
    detailParams () {
      return {
        ccoId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: cityCustomerOrderQueryByCcoId,
    editApi: cityCustomerOrderSaveOrUpdate,
    // 处理对比参数
    adjustCompareParams (compareParams) {
      compareParams.orderTimeStr = this.formatDate(compareParams.orderTimeStr);
      compareParams.deliveryTime = this.formatDate(compareParams.deliveryTime, 2);
    },
    toAddNewAddress (addressType) {
      if (this.$refs.baseForm) {
        this.$refs.baseForm.toAddNewAddress(addressType);
      }
    },
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
